export default {
  web: {
    status: {
      notFoundTitle: "Page introuvable",
      notFoundDescription: "La page que vous cherchez n'existe pas ou a peut-être été déplacée.",
      supportTitle: "Support",
      supportDescription: "Pour obtenir de l'aide avec votre compte ou poser une question sur nos services, contactez-nous par courriel à support@linemate.io",
      goHome: "Aller à l'accueil",
      exploreTrends: "Explorer les tendances",
      openTrends: "Ouvrir les tendances",
      contactSupport: "Contacter le support",
    },
    download: {
      title: "Télécharger Linemate",
      subtitle: "Disponible sur iOS, Android et le web.",
      ios: "Télécharger pour iOS",
      android: "Télécharger pour Android",
    },
    manageSubscription: {
      title: "Gérer votre abonnement",
      web: "Gérer sur le web",
      ios: "Gérer sur iOS",
      android: "Gérer sur Android",
    },
    auth: {
      loginTitle: "Connexion à Linemate",
      signupTitle: "Créer un compte Linemate",
      noAccount: "Vous n'avez pas de compte?",
      alreadyHaveAccount: "Vous avez déjà un compte?",
      signUp: "Créer un compte",
      setupError: "Une erreur est survenue lors de la configuration de votre compte. Vous pourrez peut-être terminer le processus depuis la page de profil.",
      usernameTooShort: "Le nom d'utilisateur est trop court (min. 6 caractères).",
      usernameAlphaNumeric: "Le nom d'utilisateur ne peut contenir que des lettres et des chiffres.",
      termsPrefix: "En continuant, vous acceptez les",
      termsOfService: "Conditions d'utilisation",
      privacyPolicy: "Politique de confidentialité.",
      oddsFormatTitle: "Préférences de format des cotes",
      oddsFormatDescription: "Avant de continuer vers Linemate, veuillez définir votre préférence d'affichage des cotes en format américain ou décimal.",
      oddsFormat: "Format des cotes",
      passwordReset: {
        forgotTitle: "Mot de passe oublié",
        resetTitle: "Réinitialiser le mot de passe",
        instructions: "Entrez l'adresse courriel associée à votre compte et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
        sentInstructions: "Vous recevrez bientôt un courriel de réinitialisation. Suivez le lien dans le courriel pour réinitialiser votre mot de passe.",
        sendInstructions: "Envoyer les instructions",
        resendInstructions: "Renvoyer les instructions",
        returnToLogin: "Retour à la connexion",
        signupPrompt: "Vous n'avez pas de compte? Créer un compte",
        sendError: "Une erreur est survenue lors de l'envoi des instructions de réinitialisation. Veuillez réessayer plus tard.",
      },
      changePassword: {
        title: "Modifier votre mot de passe",
        subtitle: "Entrez votre nouveau mot de passe.",
        newPassword: "Nouveau mot de passe",
        confirmNewPassword: "Confirmer le nouveau mot de passe",
        passwordChanged: "Mot de passe modifié",
        invalidLink: "Nous n'avons pas pu réinitialiser votre mot de passe. Le lien que vous utilisez est invalide ou expiré.",
        genericError: "Nous n'avons pas pu compléter votre demande. Veuillez réessayer plus tard ou envoyer le code suivant à notre équipe afin que nous puissions l'examiner: {{code}}",
      },
    },
    inputSelection: {
      clear: "Effacer",
    },
  },
};
